import { toast, ToastOptions } from 'react-toastify';
import _ from 'lodash';

const MOBILE_BREAK_POINT = 900;

const getToastOptions = (): ToastOptions => {
  const isMobile = window.innerWidth < MOBILE_BREAK_POINT;

  return {
    // At the bottom of a phone screen the toast covers the next document
    // to acknowledge and the browser controls, so it is shown on top instead.
    position: isMobile ? 'top-center' : 'bottom-right',
    autoClose: isMobile ? 3000 : 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
};

export const showToast = (content: string, type?: string) => {
  if (type === 'success') {
    toast.success(content, getToastOptions());
    return;
  }

  if (type === 'error') {
    toast.error(_.capitalize(content), getToastOptions());
    return;
  }

  toast(content, getToastOptions());
};
